import React, { useEffect, useState } from "react";
import styles from "./CouncilNewsCard.module.scss";
import moment from "moment";
import InfoButton from "../../Atoms/InfoButton/InfoButton";
import moreInfo from "../../../assets/icons/programs/major/moreInfo.svg";
import editSvg from "../../../assets/icons/formActions/edit.svg";
import deleteSvg from "../../../assets/icons/formActions/delete.svg";
import { useNavigate } from "react-router-dom";
import DeletePopup from "../Custom/DeletePopup";
import { useDeleteNews } from "../../../Hooks/News";
import NewsCouncilInfoModal from "./NewsCouncilInfoModal";
import placeholderImage from "../../../assets/Imagess/no-image-found.jpg";
import { isEmpty } from "lodash";
import newsUpdated from "../../../assets/Imagess/news-updated.png";
import { useMutation } from "react-query";
import axios from "axios";
import { API_URL, securityHeaders } from "../../../Constants";
import he from "he";
import ActivityStatus from "../../Atoms/Inputs/ActivityStatus";
import { useDeleteCouncilNews } from "../../../Hooks/Council";
import { useToast } from "../Custom/CustomToaster/Toast";
import { sanitizeAndValidateUrl } from "../../../app/helpers/sanitizeAndValidateUrl";

function CouncilNewsCard({ program, refetch, selected }) {
  const [showInfo, setShowInfo] = useState(false);
  const customizedToast = useToast();
  const navigate = useNavigate();
  const [showDeletePopup, setShowDeletePopup] = useState(false);
  const [showCheckmark, setShowCheckmark] = useState(false);
  const [isActive, setIsActive] = useState(!!false);
  const {
    mutate: deleteNews,
    isLoading: isDeletingNews,
    isSuccess,
  } = useDeleteCouncilNews(program?.newsId);

  useEffect(() => {
    setIsActive(!!program?.isActive);
  }, [program]);

  const menuItems = [
    {
      label: 'تعديل',
      icon: editSvg,
      onClick: () => {
        navigate(
          `/home/edit-council-news/${
            'students' === selected
              ? 0
              : 'parents' === selected
              ? 1
              : 'cadets-students' === selected
              ? 2
              : 'faculty-members' === selected
              ? 3
              : 4
          }/${program?.newsId}`
        );
      },
    },
    {
      label: 'حذف',
      icon: deleteSvg,
      onClick: () => {
        setShowDeletePopup(true);
      },
    },
  ];

  useEffect(() => {
    refetch();
  }, [isDeletingNews]);

  useEffect(() => {
    if (isSuccess) {
      // setShowCheckmark(true);
      customizedToast.open(' تم الحذف بنجاح');
      setTimeout(() => {
        setShowCheckmark(false);
      }, 2000);
    }
  }, [isSuccess]);

  const activateNews = useMutation({
    mutationFn: () => {
      return axios.post(
        API_URL + `/api/News/ActivateNews/${program?.newsId}/${!isActive}`,
        {},
        {
          headers: securityHeaders,
        }
      );
    },
    onSuccess: (data) => {
      setIsActive(!isActive);
      refetch();
    },
    onError: (error) => {
      alert(error?.message);
    },
  });

  const decodedHTML = program ? he.decode(program.newsTextEn) : "";

  return (
    <div className={styles['news-card']}>
      {isEmpty(program?.image) ? (
        <img src={placeholderImage} className={styles['news-card-image']} />
      ) : (
        <img
          src={sanitizeAndValidateUrl(`${program?.url}${program?.image}`)}
          className={styles['news-card-image']}
          onClick={() => setShowInfo(true)}
        />
      )}
      <div className={styles['news-card-info']}>
        <div className={styles['row']}>
          <p className={styles['name']}>{program?.category_EN}</p>
          <p className={styles['date']}>
            {moment(program?.dateCreated).format('DD/MM/YYYY')}
          </p>
        </div>
        <div className={styles['row']}>
          <div className={styles['description']}>
            <p
              className={styles['text']}
              dangerouslySetInnerHTML={{ __html: decodedHTML }}
            />
          </div>
          <InfoButton
            icon={moreInfo}
            className={styles['more-info']}
            data={menuItems}
          />
        </div>
      </div>
      {showDeletePopup && (
        <DeletePopup
          handleOnClose={() => setShowDeletePopup(false)}
          title="الأخبار"
          handleDelete={() => {
            deleteNews();
            setShowDeletePopup(false);
          }}
          isLoading={isDeletingNews}
        />
      )}
      {showInfo && (
        <NewsCouncilInfoModal
          news={program}
          handleOnClose={() => setShowInfo(false)}
          setShowDeletePopup={setShowDeletePopup}
        />
      )}
      {showCheckmark && (
        <div className={styles['checkmark']}>
          <img src={newsUpdated} />
        </div>
      )}
      {/* <ActivityStatus isActive={isActive} activate={activateNews} /> */}
    </div>
  );
}

export default CouncilNewsCard;
